import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import App from './App';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Acessibilidade from './Institucional/Acessibilidade';
import Proposicoes from './Proposicoes/Proposicoes';
import ProposicaoDetalhes from './Proposicoes/ProposicaoDetalhes';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />}>
          <Route index element={<Proposicoes />} />
          <Route path="/acessibilidade" element={<Acessibilidade />} />
          <Route path="/proposicoes/detalhes" element={<ProposicaoDetalhes />} />
        </Route>
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);